import React from 'react'
import { Modal } from 'antd'
import { arrayMoveImmutable } from 'array-move'
import {
  ActionWrap,
  ButtonDiv,
  ContentFlex,
  FlexWrap,
  Heading,
  MainFlex,
} from 'components/DragDiv/style'
import Flex from 'components/Flex'
import DeleteIcon from 'components/icons/DeleteIcon'
import DragIcon from 'components/icons/DragIcon'
import EditIcon from 'components/icons/EditIcon'
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc'
const { confirm } = Modal

const DragDiv = ({
  headingParam = 'name',
  descriptionParam = 'description',
  sortedItems = ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
  setSortedItems,
  onEditClick,
  disabled = false,
  availableItem = [],
  disableDelete = false,
  disableEdit = false,
  round = false,
}) => {
  const DragHandle = sortableHandle(({ isDragLocked }) => (
    <span style={{ cursor: isDragLocked ? 'not-allowed' : 'grab' }}>
      <DragIcon />
    </span>
  ));

  const SortableItem = sortableElement(({ value }) => {
    const itemHasStudents = (value?.applied || 0) > 0
    const isDragLocked = itemHasStudents
    const editIsDisabled = disabled || disableEdit || itemHasStudents
    return (
      <FlexWrap centerVertically>
        <ContentFlex width="85%" gap="10px" centerVertically>
          <Flex centerVertically>
            <DragHandle isDragLocked={isDragLocked} />
          </Flex>
          <ContentFlex column>
            <Heading>{value[headingParam]}</Heading>
            <div
              dangerouslySetInnerHTML={{ __html: value[descriptionParam] }}
            ></div>
          </ContentFlex>
        </ContentFlex>
        <ActionWrap centerVertically>
          <ButtonDiv
            onClick={() => {
              if (editIsDisabled) return
              onEditClick(
                value,
                'edit',
                editIsDisabled &&
                availableItem
                  ?.map(item => item?.name)
                  ?.includes(value[headingParam])
              )
            }}
            style={{ cursor: editIsDisabled ? 'not-allowed' : 'pointer' }}
          >
            <EditIcon />
          </ButtonDiv>
          {value?.applied == undefined || value?.applied === 0 ? (
            <ButtonDiv
              onClick={() => {
                if (disabled || disableDelete) return
                confirm({
                  zIndex: 1001,
                  title: `Delete ${value?.name}?`,
                  okText: 'Confirm',
                  okType: 'primary',
                  cancelText: 'Cancel',
                  onOk: () => {
                    Modal.destroyAll()
                    onEditClick(value, 'delete')
                  },
                })
              }}
              style={{ cursor: disabled || disableDelete ? 'not-allowed' : 'pointer' }}
            >
              <DeleteIcon />
            </ButtonDiv>
          ) : null}
        </ActionWrap>
      </FlexWrap>
    )
  })

  const SortableContainer = sortableContainer(({ children }) => {
    return <MainFlex column>{children}</MainFlex>
  })

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const draggedItem = sortedItems[oldIndex]
    const targetItem = sortedItems[newIndex]

    // Don't allow dragging a round that already has students (applied > 0)
    if ((draggedItem?.applied || 0) > 0) {
      return
    }

    // Don't allow dropping an empty round before a round that has students
    if ((draggedItem?.applied || 0) === 0 && (targetItem?.applied || 0) > 0) {
      return
    }

    setSortedItems(items => {
      const newItems = arrayMoveImmutable(items, oldIndex, newIndex)
      return newItems.map((item, i) => ({
        ...item,
        order: i + 1,
      }))
    })
  }
  return (
    <SortableContainer
      onSortEnd={onSortEnd}
      useDragHandle
      disabled={disabled}
    >
      {sortedItems?.map((value, index) => (
        <SortableItem
          key={`item-${index}` + value}
          index={index}
          value={value}
          disabled={
            disabled ||
            value?.applied > 0 ||
            (round === 'round' ? value?.isOngoing : false)
          }
        />
      ))}
    </SortableContainer>
  )
}

export default DragDiv
